import { ThemeOptions } from "@mui/material";

export const muiCssBaseline: ThemeOptions["components"] = {
  MuiCssBaseline: {
    styleOverrides: theme => {
      return {
        "#onfido-container > div": {
          border: "none",
          minHeight: `calc(100dvh - 10px)`,
        },
        "html, body, #root": {
          height: "100%",
        },
        "html, body": {
          fontFamily: "AppMainFont",
          backgroundColor: theme.palette.background.default,
        },
        a: {
          textDecoration: "none",
          color: theme.palette.typography.link,
        },
        p: {
          margin: 0,
        },
        ul: {
          margin: 0,
          paddingInlineStart: 16,
        },
        input: {
          "&:-webkit-autofill": {
            padding: "inherit",
            WebkitBoxShadow: `0 0 0 40px ${theme.palette.sectionBackground.primary} inset !important;`,
          },
          "&:-webkit-autofill:hover": {
            WebkitBoxShadow: `0 0 0 40px ${theme.palette.sectionBackground.primary} inset !important;`,
          },
          "&:-webkit-autofill:focus": {
            WebkitBoxShadow: `0 0 0 40px ${theme.palette.sectionBackground.primary} inset !important;`,
          },
          "&:-webkit-autofill:active": {
            WebkitBoxShadow: `0 0 0 40px ${theme.palette.sectionBackground.primary} inset !important;`,
          },
        },
        ".bold": {
          fontWeight: 700,
        },
        ".flexCenter": {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "20px",
        },
        ".hype-list": {
          paddingLeft: "30px",
          margin: 0,
        },
        ".hidden": {
          height: 0,
          width: 0,
          margin: 0,
          padding: 0,
          border: "none",
        },
        ".MuiInputBase-input::placeholder": {
          opacity: 1, // Imposta l'opacità al massimo per rendere il placeholder visibile
        },
        ".MuiDialogContent-root ul": {
          margin: 0,
          paddingLeft: "25px",
          marginBottom: "25px",
        },
        ".color-dark": { color: theme.palette.text.primary },
        ".color-primary": { color: theme.palette.primary.main },
        // ".color-secondary": { color: theme.palette.secondary.main },
        ".font-size-18": { fontSize: 18 },
        ".font-size-14": { fontSize: 14 },
        ".font-size-12": { fontSize: 12 },
        ".align-justify": { textAlign: "justify" },
        ".align-center": { textAlign: "center" },
        ".hList.hCard": {
          li: {
            padding: "0px",
            "> div, div.MuiListItem-root": {
              marginTop: "0px!important",
              marginBottom: 0,
            },
          },
        },
        ".grecaptcha-badge": {
          visibility: "hidden",
        },
      };
    },
  },
};
